import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import {useRouter} from "vue-router";
import {FlightModel} from "@/models/flight.model";

export interface Props {
    flight: FlightModel
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FlightWidget',
  props: {
    flight: {}
  },
  setup(__props: any) {


const props = __props;
const router = useRouter();

function details(id: number) {
    router.push({
        path: '/flight/' + id
    })
}

function getDestinationImageUrl(dest: string) {
    return 'https://img.pequla.com/destination/' + dest.toLowerCase().split(' ')[0] + '.jpg';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    onClick: _cache[0] || (_cache[0] = (e)=>details(props.flight.id)),
    class: "flight-box"
  }, [
    _createElementVNode("p", null, [
      _createElementVNode("img", {
        src: getDestinationImageUrl(props.flight.destination),
        width: "300"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("h3", null, _toDisplayString(props.flight.destination) + " (" + _toDisplayString(props.flight.flightNumber) + ")", 1),
    _createElementVNode("p", null, _toDisplayString(props.flight.scheduledAt), 1)
  ]))
}
}

})